import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { Fiat } from "@models";
import { Currency } from "@models/interfaces/currency";
import { Tradable } from "@models/interfaces/tradable";
import { LIMIT_ORDER_FIAT_PRECISION } from "@modules/trade/constants/constants";

export interface FiatPrecisionModel {
	amount: number | string;
	id: string;
	currency: Currency[];
	hasDescription: boolean;
	description: string;
	precision: number;
	fiat?: Fiat;
	stableCoin?: Tradable;
}

@Component({
	selector: "order-fiat",
	templateUrl: "./order-fiat.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class OrderFiatComponent {
	@Input() public fiatModel: FiatPrecisionModel;
	public readonly fiatPrecisionLO = LIMIT_ORDER_FIAT_PRECISION;
}
